import * as React from 'react';
import * as _ from 'lodash';
import * as moment from 'moment';
import { IMainstreetEvent } from '../classes';
import { calendarDispatch } from '../calendar'
import { setInstructorFilter } from '../actions';

interface ICalendarFiltersInstructor {
    selectedInstructorFilter: string;
}

class CalendarFiltersInstructor extends React.Component<ICalendarFiltersInstructor, any>{
    instructorList: Array<any>;

    constructor(props) {
        super(props);
        this.instructorList = (window as any).filterOptions.instructor;
        var monthCounter = moment();
    }

    render() {
        return (
            <div>
                <label>By Instructor</label>
                <select onChange={this.sendAction.bind(this)} value={this.props.selectedInstructorFilter}>
                    <option value={""}>All</option>
                    {
                        this.instructorList.map((instructor) => <option key={instructor} value={instructor}> {instructor}</option>)
                    }
                </select>
            </div>
        )
    }
    sendAction(e) {
        //up
        moment(e.target.value)

        console.log(e.target.value);
        calendarDispatch()(setInstructorFilter(e.target.value));

    }
};

export default CalendarFiltersInstructor;



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/calendar/filters/calendar-filters-instructor.tsx